import styled from 'styled-components';

const Wrapper = styled.div`
  .dashboard-heading{
        color: rgb(55, 65, 81);
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .dashboard-header{
        display : flex;
        justify-content: space-between;
    }
    .handleDropdown{
        display : flex;
        gap : 10px;
    }
    .grid-item-dash-top{
        color: #4F4F4F;
        font-weight: 600;
    }
    .grid-item-dash-top{
        display: flex;
        justify-content: space-between;
    }
    .grid-item-dash-top-circle{
        display: flex;
        padding: 10.973px 11.757px;
        align-items: center;
        gap: 7.838px;
           border-radius: 7837.245px;
        }
    .purple-cir{
        background: #F3E8FF;
        box-shadow: 0 6px 0 #B08CFF, 0 6px 15px rgba(0, 0, 0, 0.2);
    }
    .green-cir{
        background: #DCFCE7;
        box-shadow: 0 6px 0 #4ADE80, 0 6px 15px rgba(0, 0, 0, 0.2);
    }
    .blue-cir{
        background: #DBE9FE;
         box-shadow: 0 6px 0 #3B82F6, 0 6px 15px rgba(0, 0, 0, 0.2);
    }
    .skyBlue-cir{
        background: #D2F4FF;
         box-shadow: 0 6px 0 #22D3EE, 0 6px 15px rgba(0, 0, 0, 0.2);
    }
         .yellow-cir{
        background: #f8e69eff;
         box-shadow: 0 6px 0 #FACC15, 0 6px 15px rgba(0, 0, 0, 0.2);
    }

    .grid-item-dash-numb{
        color: #4C4C4C;
        font-size: 32px;
        font-weight: 700;
        margin-bottom: 0;
        margin-top: 10px;
    }
    .text-big {
        font-size: 2rem;
    }
    
        .relativeBottom{
            position: relative;
             bottom: 1rem; 
        }



.grid-item-dash-top-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
//  box-shadow: 0 6px 0 #dc3545, 0 6px 15px rgba(0, 0, 0, 0.2);
  user-select: none;
}



.grid-item-dash-top-circle:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 0 #009778, 0 8px 20px rgba(0,0,0,0.25);
}

.grid-item-dash-top-circle:active {
  transform: translateY(4px);
  box-shadow: 0 2px 0 #d6a500, 0 2px 8px rgba(0,0,0,0.15);
}


.FourCardGrid {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 14px 14px;
  align-items: stretch;
}

/* Cards */
.grid-item-dash {
  padding: 20px 24px;
  min-height: 120px;
}

.center-circle-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: #ffffff;
  z-index: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 9px solid #fafbfc;
  // box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
}

/* Make room INSIDE cards */
.grid-item-dash:nth-child(2),
.grid-item-dash:nth-child(3) {
  padding-bottom: 40px;
}

.grid-item-dash:nth-child(4),
.grid-item-dash:nth-child(5) {
  padding-top: 40px;
}

/* Text */
.center-circle-title {
        font-size: 14px;
        margin-bottom: 2px;
        color: rgb(79, 79, 79);
        font-weight: 600;
    }

.center-circle-number {
  font-size: 20px;
  font-weight: 800;
  color: #111827;
}




/* =========================
   RESPONSIVE – MOBILE
========================= */
@media (max-width: 768px) {

  
  .FourCardGrid {
    grid-template-columns: 1fr;
    gap: 16px;
    position: static;
  }

  .grid-item-dash {
    padding: 16px;
    min-height: auto;
  }

  .center-circle-card {
    width: 100%;
    height: auto;
    min-height: 72px;

    border-radius: 14px; /* card-like */
    padding: 12px 16px;
    margin: 12px 0;

    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    position: relative;
    top: auto;
    left: auto;
    transform: none;
    border: 9px solid #ffffff;
    // box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  }

  .center-circle-title {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .center-circle-number {
    font-size: 18px;
  }

  .grid-item-dash-numb {
    font-size: 24px;
  }

  .grid-item-dash-top {
    font-size: 14px;
  }

  .grid-item-dash-top-circle {
    width: 36px;
    height: 36px;
    font-size: 20px;
  }

  /* Reset desktop padding tricks */
  .grid-item-dash:nth-child(2),
  .grid-item-dash:nth-child(3),
  .grid-item-dash:nth-child(4),
  .grid-item-dash:nth-child(5) {
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .relativeBottom {
    bottom: 0;
  }
}

/* =========================
   SMALL PHONES
========================= */
@media (max-width: 480px) {


  .grid-item-dash-numb {
    font-size: 22px;
  }

 .center-circle-card {
    width: 100%;
    height: auto;
    min-height: 72px;

    border-radius: 14px; /* card-like */
    padding: 12px 16px;
    margin: 12px 0;

    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    position: relative;
    top: auto;
    left: auto;
    transform: none;
        border: 9px solid #ffffff;
    // box-shadow: 0 8px 18px rgba(0, 0, 0, 0.12);
  }

  .center-circle-title {
    font-size: 13px;
    margin-bottom: 2px;
  }

  .center-circle-number {
    font-size: 18px;
  }

  .center-circle-number {
    font-size: 16px;
  }
}


`;


export default Wrapper;
